/**
 * Canadian provinces and territories — single source of truth.
 * Stored value in DB: 2-letter ISO code (e.g. 'QC', 'BC').
 * 'XX' is the sentinel for "outside Canada".
 */
export const CANADIAN_PROVINCES = [
    { code: 'AB', fr: 'Alberta',                   en: 'Alberta'                   },
    { code: 'BC', fr: 'Colombie-Britannique',       en: 'British Columbia'          },
    { code: 'MB', fr: 'Manitoba',                   en: 'Manitoba'                  },
    { code: 'NB', fr: 'Nouveau-Brunswick',          en: 'New Brunswick'             },
    { code: 'NL', fr: 'Terre-Neuve-et-Labrador',    en: 'Newfoundland and Labrador' },
    { code: 'NS', fr: 'Nouvelle-Écosse',            en: 'Nova Scotia'               },
    { code: 'NT', fr: 'Territoires du Nord-Ouest',  en: 'Northwest Territories'     },
    { code: 'NU', fr: 'Nunavut',                    en: 'Nunavut'                   },
    { code: 'ON', fr: 'Ontario',                    en: 'Ontario'                   },
    { code: 'PE', fr: 'Île-du-Prince-Édouard',      en: 'Prince Edward Island'      },
    { code: 'QC', fr: 'Québec',                     en: 'Quebec'                    },
    { code: 'SK', fr: 'Saskatchewan',               en: 'Saskatchewan'              },
    { code: 'YT', fr: 'Yukon',                      en: 'Yukon'                     },
    { code: 'XX', fr: 'Hors Canada',                en: 'Outside Canada'            },
];

/**
 * Returns the translated province name for a given code.
 * Falls back to the code itself if not found.
 */
export const getProvinceName = (code, language = 'fr') => {
    if (!code) return '';
    const p = CANADIAN_PROVINCES.find(p => p.code === code);
    if (!p) return code;
    return language === 'en' ? p.en : p.fr;
};
